export const closeMenu = () => {
    $('.menu-item:first-child').click(function () {
        $('#block-thomaspiron-main-menu').removeClass('menu-active');
        $('body').css('overflow','auto');
    })
}